import * as React from 'react';
import { Component } from 'react';
import './LogIn.css';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';
import { IUserInfo } from '../../models/IUserInfo';
import Footer from './Footer';
import { ImageContainer } from './ImageContainer';

function MapState(state) {
    return {
        UserInfo: state.Profile
    }
}

interface IProps extends RouteComponentProps<any> {
    UserInfo: IUserInfo | null
}

class RegisterErrorComponent extends Component<IProps, any> {
    constructor(props) {
        super(props);
    }

    public render() {
        return (
            <div className="login-component route-component">
                <div className="content-container">
                    <div className="content">
                        <div className="form-container">
                            <div className="kif-logo" />
                            <div className="header">
                                <h3>Potwierdzenie adresu email</h3>
                                <span className="sub-header">Nie udało się potwierdzić adresu email, dlatego link stracił ważność. Spróbuj zarejestrować się ponownie</span>
                            </div>
                            <div className="submit-success-container">
                                <div className="form-buttons">
                                    <input type="submit" className="confirm-button-orange" value="Zarejestruj się" onClick={this.RedirectToRegister} />
                                </div>
                            </div>
                        </div>
                        <ImageContainer />
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }//end-of-render

    private RedirectToRegister = (evt) => {
        this.props.history.push('/register');
    }

}

export default connect(MapState)(RegisterErrorComponent);


// WEBPACK FOOTER //
// ./src/components/Login/RegisterError.tsx